/** Shared rounded UI tokens for hiring content — PaceHRM DS theme. */

export const PORTAL_MAIN_CLASS = "portal-main";

/** Wrapper for candidate-only pages (curvy layout via .portal-candidate in index.css). */
export const PORTAL_CANDIDATE_PAGE = "portal-candidate-page";

export const PORTAL_CANDIDATE_CARD =
  "bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl shadow-[var(--ds-shadow-card)] overflow-hidden";

export const PORTAL_CANDIDATE_ALERT = "text-sm rounded-xl border px-3 py-2";

export const PORTAL_CANDIDATE_BTN =
  "px-3 py-1.5 text-xs font-medium rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-fg))] hover:bg-[hsl(var(--ds-muted))] shadow-sm transition-colors";

/** Inputs inside candidate modals & forms (refer, interview, offer). */
export const PORTAL_CANDIDATE_INPUT =
  "border border-[hsl(var(--ds-border))] px-3 py-2 text-sm w-full rounded-xl bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-fg))] shadow-sm focus:outline-none focus:border-[hsl(var(--ds-primary))] focus:ring-1 focus:ring-[hsl(var(--ds-ring))]";

export const PORTAL_CANDIDATE_TEXTAREA =
  "border border-[hsl(var(--ds-border))] px-3 py-2 text-sm w-full rounded-xl bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-fg))] shadow-sm focus:outline-none focus:border-[hsl(var(--ds-primary))] focus:ring-1 focus:ring-[hsl(var(--ds-ring))] resize-y min-h-[4rem]";

export const PORTAL_CANDIDATE_REFER_BTN =
  "px-3 py-1.5 text-xs font-medium rounded-xl border border-[hsl(var(--ds-primary))] text-[hsl(var(--ds-primary))] bg-[hsl(var(--ds-surface))] hover:bg-[hsl(var(--ds-primary)/0.08)] shadow-sm transition-colors";

export const PORTAL_CANDIDATE_TABLE_WRAP =
  "bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl shadow-[var(--ds-shadow-card)] overflow-hidden";

export const PORTAL_TABLE_CARD =
  "bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl shadow-[var(--ds-shadow-card)] overflow-hidden";

/** Table card without overflow-hidden — required for horizontal sticky columns */
export const PORTAL_TABLE_CARD_STICKY =
  "bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl shadow-[var(--ds-shadow-card)]";

export const PORTAL_TABLE_SCROLL = "overflow-x-auto max-h-[520px] overflow-y-auto";

/** Flex list page — header/filters fixed, table card fills remaining height */
export const PORTAL_LIST_PAGE =
  "flex flex-col flex-1 min-h-0 overflow-hidden gap-4 portal-list-page min-w-0";

/** Scrollable table region inside a list page card */
export const PORTAL_LIST_TABLE_SCROLL =
  "portal-list-table-scroll flex-1 min-h-0 overflow-x-scroll overflow-y-auto";

export const PORTAL_BTN_PRIMARY =
  "border border-[hsl(var(--ds-primary))] bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-primary))] px-3 py-2 text-sm font-medium rounded-xl hover:bg-[hsl(var(--ds-primary)/0.08)] hover:border-[hsl(var(--ds-primary-hover))] hover:text-[hsl(var(--ds-primary-hover))] shadow-sm disabled:opacity-60 transition-colors";

export const PORTAL_BTN_SECONDARY =
  "px-3 py-2 text-sm border border-[hsl(var(--ds-border))] rounded-xl bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-fg))] hover:bg-[hsl(var(--ds-muted))] shadow-sm transition-colors";

export const PORTAL_BTN_DANGER =
  "border border-[hsl(var(--ds-danger))] bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-danger))] px-3 py-2 text-sm font-medium rounded-xl hover:bg-[hsl(var(--ds-danger)/0.08)] shadow-sm disabled:opacity-60 transition-colors";

export const PORTAL_BTN_SUCCESS =
  "border border-[hsl(var(--ds-success))] bg-[hsl(var(--ds-surface))] text-[hsl(var(--ds-success))] px-3 py-2 text-sm font-medium rounded-xl hover:bg-[hsl(var(--ds-success)/0.08)] shadow-sm disabled:opacity-60 transition-colors";

/** Form field label — matches product ds-caption / DsLabel feel */
export const PORTAL_LABEL =
  "ds-caption mb-1.5 block text-[hsl(var(--ds-muted-fg))]";

/** Standard text input / select for hiring forms */
export const PORTAL_INPUT =
  "h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none placeholder:text-[hsl(var(--ds-muted-fg))] hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]";

export const PORTAL_TEXTAREA =
  "w-full min-h-[4.5rem] rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 py-2 text-sm text-[hsl(var(--ds-fg))] outline-none placeholder:text-[hsl(var(--ds-muted-fg))] hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))] resize-y";

export const PORTAL_SECTION =
  "rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] shadow-[var(--ds-shadow-card)] p-4";

export const PORTAL_SECTION_TITLE =
  "ds-h4 text-[hsl(var(--ds-fg))]";

export const PORTAL_TAB_ACTIVE =
  "rounded-xl border border-[hsl(var(--ds-primary))] bg-[hsl(var(--ds-surface))] px-4 py-2 text-sm font-semibold text-[hsl(var(--ds-primary))] shadow-sm";

export const PORTAL_TAB_IDLE =
  "rounded-xl border border-transparent px-4 py-2 text-sm font-medium text-[hsl(var(--ds-muted-fg))] hover:text-[hsl(var(--ds-fg))] hover:bg-[hsl(var(--ds-muted))]";

export const PORTAL_PAGE_HEADER = "text-xl font-semibold text-[hsl(var(--ds-fg))]";

/** Soft semantic badges */
export const PORTAL_BADGE_SUCCESS =
  "inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-xl border border-[hsl(var(--ds-success)/0.25)] bg-[hsl(var(--ds-success)/0.12)] text-[hsl(var(--ds-success))]";
export const PORTAL_BADGE_WARNING =
  "inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-xl border border-[hsl(var(--ds-warning)/0.35)] bg-[hsl(var(--ds-warning)/0.15)] text-[hsl(var(--ds-warning-fg))]";
export const PORTAL_BADGE_DANGER =
  "inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-xl border border-[hsl(var(--ds-danger)/0.25)] bg-[hsl(var(--ds-danger)/0.12)] text-[hsl(var(--ds-danger))]";
export const PORTAL_BADGE_MUTED =
  "inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-muted))] text-[hsl(var(--ds-muted-fg))]";
export const PORTAL_BADGE_PRIMARY =
  "inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-xl border border-[hsl(var(--ds-primary)/0.25)] bg-[hsl(var(--ds-primary)/0.1)] text-[hsl(var(--ds-primary))]";

/** Sticky table column — candidate name stays visible on horizontal scroll */
export const PORTAL_STICKY_CANDIDATE_TH =
  "text-left px-4 py-2 whitespace-nowrap sticky left-0 z-20 bg-[hsl(var(--ds-muted))] border-r border-[hsl(var(--ds-border))] shadow-[2px_0_4px_-2px_rgba(0,0,0,0.06)]";

export const PORTAL_STICKY_CANDIDATE_TD =
  "sticky-portal-candidate px-4 py-2 whitespace-nowrap sticky left-0 z-10 bg-[hsl(var(--ds-surface))] border-r border-[hsl(var(--ds-border))] shadow-[2px_0_4px_-2px_rgba(0,0,0,0.06)] align-middle min-w-[10rem] max-w-[14rem]";

export const PORTAL_STICKY_ACTIONS_TH =
  "sticky-portal-actions-head text-left px-4 py-2 sticky right-0 bg-[hsl(var(--ds-muted))] z-20 whitespace-nowrap border-l border-[hsl(var(--ds-border))]";

export const PORTAL_STICKY_ACTIONS_TD =
  "sticky-portal-actions px-4 py-2 text-right sticky right-0 bg-[hsl(var(--ds-surface))] z-10 whitespace-nowrap border-l border-[hsl(var(--ds-border))]";

/** Candidates list — freeze Sl No through Candidate + Actions on horizontal scroll */
export const PORTAL_CANDIDATES_TABLE =
  "portal-candidates-table w-full text-sm border-separate border-spacing-0";

/** Curvy pill badges (stage, status, tags) */
export const PORTAL_BADGE =
  "inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-xl";

/** ATS table — freeze Sl No through Candidate (see .portal-ats-table in index.css) */
export const PORTAL_ATS_TABLE = "portal-ats-table w-full text-sm";
